import { AnimationWithSize } from './AnimationWithSize';

export const Wiki = () => (
	<AnimationWithSize src="https://dam-cdn.atl.orangelogic.com/AssetLink/d8up4bbs57m1i281l14ghllan3w30h63.riv" />
);
